module.exports = __webpack_public_path__ + "img/ai_classroom_text.cf0fa41a.png";